export default "__VITE_ASSET__16iU4aBb__"